import { borders } from "./borders";
import { colors } from "./colors";
import { radii } from "./radius";
import { shadows } from "./shadows";
import { sizes } from "./sizes";

export const foundations = {
  borders,
  colors,
  radii,
  sizes,
  shadows,
};
